import { View } from "react-native";
import { Text } from "react-native-paper";
import { Job } from "./types";
import BuildingIcon from "../../svgs/BuildingIcon";
import MoneyIcon from "../../svgs/MoneyIcon";
import CalendarClockIcon from "../../svgs/CalendarClockIcon";
import { formatCompensation, formatTotalCompensation } from "../utils";
import ClockIcon from "../../svgs/ClockIcon";
import GolfBallIcon from "../../svgs/GolfBallIcon";
import GraduationCapIcon from "../../svgs/GraduationCapIcon";
import { readableDate } from "../../utils/dateUtils";
import { LinkButton } from "../../components";

interface MainDetailSectionProps {
  job: Job;
  scrollToPaySection: () => void;
}

const MainDetailSection = ({ job, scrollToPaySection }: MainDetailSectionProps) => {
  return (
    <View className="px-6">
      <Text className="text-title-3 font-700 text-ink-darkest">{job.jobTitle}</Text>
      <Text className="text-regular-normal text-ink-darker font-400">{`${job.facilities[0].city}, ${job.facilities[0].state}`}</Text>
      <View className="my-5 divide-y divide-sky-light">
        <View className="flex flex-row py-3">
          <BuildingIcon height={22} width={22} />
          <View className="pl-2">
            <Text className="text-small-normal font-700 text-ink-darker">Company</Text>
            <Text className="text-small-normal text-ink-darker font-400">{job.facilities[0].facility_name}</Text>
          </View>
        </View>

        {!job.hide_compensation_from_job_board && (
          <View className="flex flex-row py-3">
            <MoneyIcon height={22} width={22} />
            <View className="pl-2">
              <Text className="text-small-normal font-700 text-ink-darker">Pay</Text>
              <Text className="text-small-normal text-ink-darker font-500">{formatCompensation(job)}</Text>
              {!!job.total_compensation.value && (
                <>
                  <Text className="mt-3 text-small-normal text-ink-darker font-400">Total anticipated compensation up to:</Text>
                  <Text className="text-small-normal text-ink-darker font-500">{formatTotalCompensation(job)}</Text>
                </>
              )}
              {job.additional_income && (
                <View className="items-start mt-3">
                  <LinkButton onPress={scrollToPaySection}>Additional pay details</LinkButton>
                </View>
              )}
            </View>
          </View>
        )}

        <View className="flex flex-row py-3">
          <CalendarClockIcon height={22} width={22} />
          <View className="pl-2">
            <Text className="text-small-normal font-700 text-ink-darker">Position Type</Text>
            <Text className="text-small-normal text-ink-darker font-400">{job.employment_type}</Text>
          </View>
        </View>

        <View className="flex flex-row py-3">
          <ClockIcon height={22} width={22} />
          <View className="pl-2">
            <Text className="text-small-normal font-700 text-ink-darker">Posted</Text>
            <Text className="text-small-normal text-ink-darker font-400">{`${readableDate(
              new Date(job.created * 1000)
            )}`}</Text>
            <Text className="mt-3 text-small-normal font-700 text-ink-darker">Deadline</Text>
            <Text className="text-small-normal text-ink-darker font-400">{`${readableDate(
              new Date(job.submission_deadline * 1000)
            )}`}</Text>
          </View>
        </View>

        <View className="flex flex-row py-3">
          <GolfBallIcon height={22} width={22} />
          <View className="pl-2">
            <Text className="text-small-normal font-700 text-ink-darker">Experience Required</Text>
            <Text className="text-small-normal text-ink-darker font-400">{job.years_experience} Years</Text>
          </View>
        </View>

        {job.education_required[0] && (
          <View className="flex flex-row py-3">
            <GraduationCapIcon height={22} width={22} />
            <View className="pl-2">
              <Text className="text-small-normal font-700 text-ink-darker">Education Required</Text>
              <Text className="text-small-normal text-ink-darker font-400">{job.education_required[0]}</Text>
            </View>
          </View>
        )}
      </View>
    </View>
  );
};

export default MainDetailSection;
